import { render, staticRenderFns } from "./Parnassys.vue?vue&type=template&id=bc794366&scoped=true&"
import script from "./Parnassys.ts?vue&type=script&lang=ts&"
export * from "./Parnassys.ts?vue&type=script&lang=ts&"
import style0 from "./Parnassys.scss?vue&type=style&index=0&id=bc794366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc794366",
  null
  
)

export default component.exports